(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modtime-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-modtime-announcement-bar]');
    const track = root?.querySelector('[data-modtime-marquee-track]');
    const firstSet = root?.querySelector('[data-modtime-marquee-set][aria-hidden="false"]');

    if (!root || !track || !firstSet) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const syncDuration = () => {
      if (reducedMotion.matches) return;
      const setWidth = firstSet.getBoundingClientRect().width;
      const targetSpeed = window.innerWidth <= 1024 ? 35 : 52.4;
      const duration = Math.max(24, setWidth / targetSpeed).toFixed(2);
      root.style.setProperty('--modtime-announcement-duration', `${duration}s`);
    };

    const pauseWhenHidden = () => {
      track.style.animationPlayState = document.visibilityState === 'hidden' ? 'paused' : 'running';
    };

    if (document.fonts?.ready) {
      document.fonts.ready.then(syncDuration).catch(syncDuration);
    } else {
      syncDuration();
    }

    window.addEventListener('resize', syncDuration, { passive: true });
    document.addEventListener('visibilitychange', pauseWhenHidden);
    reducedMotion.addEventListener?.('change', syncDuration);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-cat-14"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mt-dial-film')){
  customElements.define('mt-dial-film',class extends HTMLElement{
    connectedCallback(){
      if(this.abort)return;
      this.abort=new AbortController();
      const signal=this.abort.signal;
      this.video=this.querySelector('video');
      this.button=this.querySelector('button');
      this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.connection=navigator.connection;
      this.visible=false;
      this.manuallyPaused=false;
      this.sync=()=>{
        const playing=!this.video.paused;
        this.dataset.playing=String(playing);
        this.button.hidden=playing||!this.visible;
        this.video.setAttribute('aria-label',this.dataset.label+'. '+(playing?this.dataset.pause:this.dataset.play));
      };
      this.video.addEventListener('playing',()=>this.sync(),{signal});
      this.video.addEventListener('pause',()=>this.sync(),{signal});
      this.video.addEventListener('error',()=>{this.video.controls=true;this.sync()},{signal});
      this.button.addEventListener('click',()=>{this.manuallyPaused=false;this.play()},{signal});
      this.video.addEventListener('click',()=>this.toggle(),{signal});
      this.video.addEventListener('keydown',event=>{
        if(event.key===' '||event.key==='Enter'){event.preventDefault();this.toggle()}
      },{signal});
      if('IntersectionObserver' in window){
        this.observer=new IntersectionObserver(entries=>{
          this.visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.3;
          this.update();
        },{threshold:[0,.3]});
        this.observer.observe(this.video);
      }
      document.addEventListener('visibilitychange',()=>this.update(),{signal});
      this.motion.addEventListener('change',()=>{
        if(this.motion.matches)this.video.pause();
        else this.update();
      },{signal});
      this.connection?.addEventListener('change',()=>{
        if(this.connection.saveData)this.video.pause();
        else this.update();
      },{signal});
      this.sync();
    }
    update(){
      if(document.hidden||!this.visible){this.video.pause();this.sync();return}
      if(!this.motion.matches&&!this.connection?.saveData&&!this.manuallyPaused)this.play();
      this.sync();
    }
    toggle(){
      if(!this.video.paused){this.manuallyPaused=true;this.video.pause()}
      else{this.manuallyPaused=false;this.play()}
    }
    play(){
      if(!this.video.getAttribute('src')){this.video.src=this.video.dataset.src;this.video.load()}
      this.video.muted=true;
      this.video.play()?.catch(()=>this.sync());
    }
    disconnectedCallback(){
      this.abort?.abort();this.abort=null;this.observer?.disconnect();this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
